<template>
    <div class="simple-horizontal-layout">
        <slot/>
    </div>
</template>

<script>
    export default {
        name: "SimpleHorizontalLayout",
        data: function () {
            return {}
        }
    }
</script>

<style lang="scss" scoped>
@import "../../styles/global";
.simple-horizontal-layout {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(20px, auto));
    grid-auto-rows: 1fr;
    grid-gap: 5px;
    margin: 5px;
    position: relative;
}
</style>